/**
 * Types to define the source of a search query
 */
export enum SearchQueryType {
  /**
   * user typed query
   */
  ORGANIC = 'organic',
  /**
   * query suggestion query
   */
  SUGGESTED = 'suggested',
}
